import { render } from "./PayrunAndBadge.vue?vue&type=template&id=14b4539d"
import script from "./PayrunAndBadge.vue?vue&type=script&lang=js"
export * from "./PayrunAndBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__